export const apiUrl =
  process.env.REACT_APP_RISE_API_CORE_URL ||
  'https://api.delijn.be/rise-api-core'
export const TRAVELINFO_TRIP_BASEURL =
  process.env.REACT_APP_TRAVELINFO_TRIP_BASEURL ||
  'https://api.delijn.be/travelinfo-trip/v1'
export const NETWORK_BASE_URL =
  process.env.REACT_APP_NETWORK_BASE_URL || 'https://api.delijn.be/network/v1'
export const TRAVELINFO_DETOUR_BASEURL =
  process.env.REACT_APP_TRAVELINFO_DETOUR_BASEURL ||
  'https://api.delijn.be/travelinfo-detour/v1'
export const TRAVELINFO_DISTURBANCE_BASEURL =
  process.env.REACT_APP_TRAVELINFO_DISTURBANCE_BASEURL ||
  'https://api.delijn.be/travelinfo-disturbance/v1'
export const TRAVELINFO_TRIP_KEY = process.env.REACT_APP_TRAVELINFO_TRIP_KEY
export const NETWORK_KEY = process.env.REACT_APP_NETWORK_KEY
export const RISE_API_CORE_KEY = process.env.REACT_APP_RISE_API_CORE_KEY

export const NO_PASSAGES = 'Er zijn geen doorkomsten op dit moment'
export const MAX_STEPS_TO_SHOW = 13
export const STEP_TYPE_CONNECTION = 'connection'
export const MINUTE = 60000
export const ISO_DATE_FORMAT = 'yyyy-MM-dd'
export const DEFAULT_API_DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ss"

export const GET_LINE_TIMETABLE_OF_STOP_FAILURE =
  'GET_LINE_TIMETABLE_OF_STOP_FAILURE'
export const GET_LINE_TIMETABLE_FAILURE = 'GET_LINE_TIMETABLE_FAILURE'
export const GET_STOPS_FAILURE = 'GET_STOPS_FAILURE'
export const MAX_LINES_TO_SHOW = 20
export const GET_CONTENTFUL_IMAGE_FAILURE = 'GET_CONTENTFUL_IMAGE_FAILURE'

export const errorMessages = {
  // TO DO messages aanpassen
  [GET_LINE_TIMETABLE_FAILURE]:
    'Het ophalen van de dienstregeling van een lijn is mislukt , probeer opnieuw',
  [GET_LINE_TIMETABLE_OF_STOP_FAILURE]:
    'Het ophalen van de dienstregeling van de halte is mislukt , probeer opnieuw',
  [GET_STOPS_FAILURE]: 'Het ophalen van de haltes is mislukt , probeer opnieuw',
  GET_PASSAGES_FAILURE:
    'Sorry, wegens technische problemen konden de doorkomsten niet geladen worden',
}

export const contentfulUrl = 'https://cdn.contentful.com/spaces'

export const contentfulSpaceId = '32fmeyn9t08i'

export const contentfulEnvironment = 'master'

export const contentfulAccessToken =
  'oaV6mxq0FX540rxj9VmTHkkYykspUD10w7Aj7TKZyNk'

export const IRTIS_ASSET_ID = '53ajeAuxEqm85djnx7ERRP'
export const IRTIS_HD_ASSET_ID = '1c5GhgDavvOZhgcj9ANYBi'
export const INFOTRAM_ASSET_ID = '1CCvzePZ30uoCyj3ohL3Yt'

export const noRealtimecopyA =
  process.env.NO_REALTIME_COPY_A || 'Geen tracking info'
export const noRealtimecopyB = process.env.NO_REALTIME_COPY_B || ''
export const noRealtimeInterval = process.env.NO_REALTIME_COPY_INTERVAL
  ? Number(process.env.NO_REALTIME_COPY_INTERVAL)
  : 90000

export const MULTIMAXI_REFRESH_INTERVAL =
  process.env.MULTIMAXI_REFRESH_INTERVAL || 30_000
export const IRTIS_REFRESH_INTERVAL =
  process.env.IRTIS_REFRESH_INTERVAL || 30_000
export const IRTIS_THEORETICAL_REFRESH_INTERVAL =
  process.env.IRTIS_THEORETICAL_REFRESH_INTERVAL || 1000 * 60 * 60 * 24
export const IRTIS_THEORETICAL_ERROR_REFRESH_INTERVAL =
  process.env.IRTIS_THEORETICAL_ERROR_REFRESH_INTERVAL || 1000 * 60 * 60
export const IRTIS_DETOURS_REFRESH_INTERVAL =
  process.env.IRTIS_DETOURS_REFRESH_INTERVAL || IRTIS_REFRESH_INTERVAL
export const IRTIS_DISTURBANCES_REFRESH_INTERVAL =
  process.env.IRTIS_DISTURBANCES_REFRESH_INTERVAL || IRTIS_REFRESH_INTERVAL

export const USE_TRAVELINFO_API =
  process.env.REACT_APP_USE_TRAVELINFO_API === 'true'
export const DETOUR_PROVIDER =
  process.env.REACT_APP_DETOUR_PROVIDER || 'HASTINFO'

export const AT_STOP_LABEL = 'Aan halte'
export const ARRIVING_LABEL = 'Komt aan'
export const DEPARTED_LABEL = 'Vertrokken'

export const APP_INSIGHTS_KEY = process.env.REACT_APP_APPLICATION_INSIGHTS_KEY

export const FF_IGNORE_REALTIME_FOR_TRIPS =
  process.env.REACT_APP_FF_IGNORE_REALTIME_FOR_TRIPS || 'false'
export const IGNORE_REALTIME_FOR_TRIPS_LINEDIRECTIONIDS =
  process.env.REACT_APP_IGNORE_REALTIME_FOR_TRIPS_LINEDIRECTIONIDS || ''

export const MULTIMAXI_SPLIT_HEADER_HEIGHT = 89
export const MULTIMAXI_SPLIT_MIN_ROW_HEIGHT = 118
export const MULTIMAXI_SPLIT_LOADBAR_HEIGHT = 5
export const MULTIMAXI_SPLIT_MAX_AMOUNT_OF_STOPS = 8

export const DEPARTURE = 'Vertrek'
export const NO_DEPARTURES = 'De komende tijd zijn er geen vertrekken'
